var exports = {
  "zr": "x620889e6--04fb9c--root",
  "x6": "x620889e6--04fb9c--button",
  "wH": "x620889e6--04fb9c--selected",
};

module.exports = exports;
